<template>
  <div class="ts-h-full">
    <div class="ts-mb-3 ts-flex ts-justify-end">
      <a 
        @click.prevent="fetchGameSet"
        href="#" 
        class="ts-border ts-px-2 ts-py-1 ts-rounded-md ts-font-robot ts-text-gray-600 hover:ts-border-pink-600 hover:ts-no-underline"
      >{{ $t('gameBetting.refresh') }}</a>
    </div>
    <div class="ts-overflow-y-scroll ts-h-4/5 ts-p-3">
      <ts-loading-banner :loading="loading">
        <div class="ts-space-y-3">
          <div
            v-for="(data, index) in game_set"
            :key="index"
            class="ts-w-full ts-flex ts-rounded-lg ts-shadow-lg ts-overflow-hidden ts-border ts-cursor-pointer hover:ts-shadow-over"
            @click.prevent="selectedGame(data)"
          >
            <div
              class="ts-text-center ts-w-20 ts-px-4"
              :class="data.gaem_type_id == 2 ? 'ts-bg-blue-800' : 'ts-bg-blue-500'"
            >
              <img
                src="@/assets/game5d_blank.png"
                class="ts-w-20 ts-mx-auto"
                alt
                v-if="data.game_type_id == 2"
              />
              <img src="@/assets/game649_blank.png" class="ts-w-20 ts-mx-auto" alt v-else />
              <p class="ts-leading-4 ts-font-semibold ts-text-white">
                {{ convertData(data.result_date) }}
                <br />
                {{ data.close_time }}
              </p>
            </div>
            <div class="ts-px-4 ts-py-2 ts-w-full ts-relative">
              <p class="ts-text-base ts-font-semibold ts-leading-none">
                <span class="ts-font-robot ts-text-blue-800">{{ data.game_set_name }}</span>
                <br />
                <small class="ts-font-robot ts-text-pink-600">{{ data.game_setting.game_setting }}</small>
              </p>
              <p>{{ $store.getters.limitStringShow(data.game_setting.description, 120) }}</p>
              <span
                v-if="model.game_set_id == data.game_set_id"
                class="ts-h-4 ts-w-4 ts-border ts-bg-blue-600 ts-rounded-full ts-absolute ts-bottom-0 ts-right-0 ts-mr-1 ts-mb-1"
              ></span>
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'gameType',
  props: ['value'],
  data() {
    return {
      loading: false,
      game_set: [],
      model: {}
    }
  },
  created() {
    this.fetchGameSet()
    this.model = this.value
  },
  methods: {
    ...mapActions('game/gameBetting', ['getGameSet']),
    fetchGameSet() {
      this.loading = true
      this.getGameSet({
        filter: {
          current_date: new Date(),
          time_available: new Date()
        }
      })
        .then(response => {
          this.game_set = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    selectedGame(value) {
      this.model.game_set_id = value.game_set_id
      this.model.game_type_id = value.game_setting.game_type_id
      this.$emit('game', value)
    },
    convertData(date) {
      return moment(date, 'DD-MM-YYYY').format('DD MMMM')
    }
  }
}
</script>